/* NH collection + product page lift (PLP/PDP 2026-09-29). Progressive enhancement only.
   1. Back-in-stock: posts the shopper's email to Klaviyo's documented client endpoint
      (POST /client/back-in-stock-subscriptions/) for the selected sold-out variant.
   2. Sold-out blocks follow the chosen variant (variant:change from the theme).
   3. Apparel cards: the two-dot indicator follows the swipe. */
(() => {
  if (window.__nhppInit) return;
  window.__nhppInit = true;
  const doc = document;

  /* ---------- 1 + 2. Back in stock ---------- */
  const initBis = () => {
    const box = doc.querySelector('[data-nh-bis]');
    if (!box) return;
    const input = box.querySelector('[data-nh-bis-email]');
    const btn = box.querySelector('[data-nh-bis-submit]');
    const msg = box.querySelector('[data-nh-bis-msg]');
    const sim = doc.querySelector('[data-nh-sim]');
    const company = box.dataset.company || 'RKmX3y';
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const say = (text, isError) => {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
      input.setAttribute('aria-invalid', isError ? 'true' : 'false');
    };

    const submit = async () => {
      if (btn.getAttribute('aria-busy') === 'true') return;
      const email = (input.value || '').trim();
      if (!EMAIL.test(email)) {
        say(email ? 'That email doesn’t look right. Check it and try again.' : 'Enter your email so we can let you know.', true);
        input.focus();
        return;
      }
      btn.setAttribute('aria-busy', 'true');
      say('', false);
      const body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${box.dataset.variant}` } }
          }
        }
      };
      try {
        const res = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(company)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        });
        if (res.status >= 200 && res.status < 300) {
          box.classList.add('is-done');
          say('You’re on the list. We’ll email you when it’s back.', false);
          input.removeAttribute('aria-invalid');
          try { window.klaviyo?.identify?.({ email }); } catch (e) { /* optional */ }
          return;
        }
        if (res.status === 400) {
          say('That email doesn’t look right. Check it and try again.', true);
          input.focus();
          return;
        }
        throw new Error(`HTTP ${res.status}`);
      } catch (e) {
        say('We couldn’t save that just now. Please try again, or email support@naughtyhut.co.nz.', true);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    };
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); submit(); }
    });
    input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true') say('', false); });

    doc.addEventListener('variant:change', (e) => {
      const v = e.detail && e.detail.variant;
      if (!v) return;
      const soldOut = v.available === false;
      box.dataset.variant = v.id;
      box.hidden = !soldOut;
      if (sim) sim.hidden = !soldOut;
      if (soldOut && box.classList.contains('is-done')) {
        box.classList.remove('is-done');
        say('', false);
      }
    });
  };

  /* ---------- 3. Apparel card dots (also for cards added by "Load more") ---------- */
  const initSwipeDots = (scope) => {
    scope.querySelectorAll('.nhp-card--apparel [data-nhc-swipe]:not([data-nhc-dots])').forEach((stage) => {
      stage.setAttribute('data-nhc-dots', '');
      const dots = stage.parentElement.querySelectorAll('.nhp-card__dots i');
      if (dots.length < 2) return;
      let raf = 0;
      stage.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const i = stage.scrollLeft > stage.clientWidth / 2 ? 1 : 0;
          dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
        });
      }, { passive: true });
    });
  };

  const start = () => {
    initBis();
    initSwipeDots(doc);
    const grid = doc.querySelector('[data-nhp-grid]');
    if (grid && grid.querySelector('.nhp-card--apparel')) new MutationObserver(() => initSwipeDots(grid)).observe(grid, { childList: true });
  };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
